import { Col, Row, Select, Space } from "antd";
import { FC } from "react";
import { useSelector } from "react-redux";
import { AddSvg } from "utils/svgs";
import { checkPermission } from "utils/utils";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {
    openDrawerHandler,
    title,
    categoryData,
    selectedCategory,
    setSelectedCategory
  } = props;
  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );

  const isAddPermission = checkPermission(userPermissions, {
    permissionName: 'SubCategories',
    permission: ['add'],
  });



  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>{title}</div>
          </Col>
          <Col>
            <Space>
              <Select
                value={selectedCategory}
                placeholder="Select Category"
                size="large"
                style={{
                  width: 300,
                  border: !selectedCategory ? '3px solid #3DCCC7' : undefined,
                  animation: !selectedCategory ? 'blinkBorder 1s infinite' : undefined,
                }}
                onChange={(value) => setSelectedCategory(value)}
                options={[
                  ...(categoryData || []).map((item: any) => ({
                    label: item?.categoryName,
                    value: item?.id 
                  }))
                ]}
              />

              <div className={styles['user-table__action']}>
                {(isAddPermission) && (
                  <button
                    className={`btn-blue ${styles['user-table__action--button']}`}
                    onClick={openDrawerHandler}
                    disabled={selectedCategory === undefined ? true : false} 
                    style={{cursor: selectedCategory === undefined ? 'not-allowed' : 'pointer'}}
                  >
                    <AddSvg />
                    <p>Add Sub Category</p>
                  </button>
                )}
              </div>
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
